import { useSelector } from "react-redux";
import {
  getAdultsCount,
  getChildrenCount,
  getInfantsInSeatCount,
  getInfantsOnLapCount,
} from "@b2bportal/core-flights";
import {
  useI18nContext,
  useI18nList,
  type Intl_ListFormatOptions,
} from "@hopper-b2b/i18n";

export type PassengerCounts = {
  adultsCount: number;
  childrenCount: number;
  infantsInSeatCount: number;
  infantsOnLapCount: number;
};

export const usePassengerCountString = (
  formatOptions?: Intl_ListFormatOptions,
  passengerCounts?: PassengerCounts
) => {
  const { t } = useI18nContext();
  const { formatList } = useI18nList();
  const adultsCount = useSelector(getAdultsCount);
  const childrenCount = useSelector(getChildrenCount);
  const infantsInSeatCount = useSelector(getInfantsInSeatCount);
  const infantsOnLapCount = useSelector(getInfantsOnLapCount);

  const countItems = [
    t("passengersInformation.adult", {
      count: passengerCounts?.adultsCount ?? adultsCount,
    }),
  ];

  if (childrenCount || passengerCounts?.childrenCount) {
    countItems.push(
      t("passengersInformation.child", {
        count: passengerCounts?.childrenCount ?? childrenCount,
      })
    );
  }

  const infantsNumber = infantsOnLapCount + infantsInSeatCount;
  const passengerInfantCount =
    (passengerCounts?.infantsInSeatCount ?? 0) +
    (passengerCounts?.infantsOnLapCount ?? 0);
  if (infantsNumber || passengerInfantCount) {
    countItems.push(
      t("passengersInformation.infant", {
        count:
          passengerCounts?.infantsInSeatCount == null
            ? infantsNumber
            : passengerInfantCount,
      })
    );
  }

  return formatList(countItems, formatOptions);
};
